import { RichText, TextSection as TextSectionData } from '@/payload-types'
import RenderRichTexComponent from '@/components/rich-text-render/richTextRender'
import { CreateAnchorLink } from '@/lib/postFunctions'

interface IProps {
  textSectionData: TextSectionData | null
}

export const TextSection = ({ textSectionData }: IProps) => {
  if (textSectionData?.content && typeof textSectionData.content === 'object') {
    return textSectionData?.content.map((item, index) => {
      if (typeof item === 'object' && item.richText) {
        const pretendRichTextBlock = {
          richText: item?.richText,
          blockType: 'RichText',
        } as RichText
        const link = textSectionData
          ? CreateAnchorLink(pretendRichTextBlock)?.href?.split('#')[1]
          : null
        return (
          <RenderRichTexComponent
            key={index}
            richTextField={item.richText}
            anochrLink={link ? link : ''}
          />
        )
      }
    })
  }
  return null
}

export default TextSection
